// StaffLayout.tsx
import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {Link} from "@heroui/react";
import { Button } from "@heroui/react";
import Navbar from "../../components/Navbar";
import { signOut } from "aws-amplify/auth";
import { VscCallOutgoing } from "react-icons/vsc";
import { BsPersonFillUp } from "react-icons/bs";
import { LuLayoutDashboard } from "react-icons/lu";
import { RiLogoutBoxLine } from "react-icons/ri";
import { IoSettingsOutline } from "react-icons/io5";

const StaffLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

const handleLogout = async (): Promise<void> => {
    try {
        await signOut();
    } catch (error) {
        console.log('Error signing out: ', error);
    }
};

  return (
    <div className="w-screen h-screen flex flex-col">
    {/* Top Navigation Bar */}
    <div className="flex flex-col items-start bg-white">
        <Navbar />
        <div className="w-full min-h-[3px] bg-yorkOrange"></div>
    </div>
      {/* Sidebar + Content Container */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <aside className={`transition-all duration-300 ${sidebarCollapsed ? 'w-[60px]' : 'w-[175px]'} bg-white border-r border-gray-200 flex flex-col justify-between`}>
          <div className="pt-4">
            <nav className="flex flex-col text-sm">
                <Link
                    href="/staff"
                    className={`
                        px-4 py-2 flex items-center transition-colors
                        ${sidebarCollapsed ? "justify-center text-[0px]" : "text-sm justify-start"}
                        ${location.pathname === "/staff" ? "bg-yorkOrange text-white" : "hover:bg-gray-300 hover:text-gray-700 text-gray-700"}
                    `}
                    >
                    {sidebarCollapsed ? (
                        <span className="text-base"><LuLayoutDashboard size={22}/></span> // or an actual icon
                    ) : (
                        "Dashboard"
                    )}
                </Link>
                <Link
                    href="/staff/callplanner"
                    className={`
                        px-4 py-2 flex items-center transition-colors
                        ${sidebarCollapsed ? "justify-center text-[0px]" : "text-sm justify-start"}
                        ${location.pathname === "/staff/callplanner" ? "bg-yorkOrange text-white" : "hover:bg-gray-300 hover:text-gray-700 text-gray-700"}
                    `}
                    >
                    {sidebarCollapsed ? (
                        <span className="text-base"><VscCallOutgoing size={22} /></span> // or an actual icon
                    ) : (
                        "Call Planner"
                    )}
                </Link>
                <Link
                    href="/staff/staffcalls"
                    className={`
                        px-4 py-2 flex items-center transition-colors
                        ${sidebarCollapsed ? "justify-center text-[0px]" : "text-sm justify-start"}
                        ${location.pathname === "/staff/staffcalls" ? "bg-yorkOrange text-white" : "hover:bg-gray-300 hover:text-gray-700 text-gray-700"}
                    `}
                    >
                    {sidebarCollapsed ? (
                        <span className="text-base"><BsPersonFillUp size={22}/></span> // or an actual icon
                    ) : (
                        "Staff Calls"
                    )}
                </Link>
                <Link
                    href="/staff/settings"
                    className={`
                        px-4 py-2 flex items-center transition-colors
                        ${sidebarCollapsed ? "justify-center text-[0px]" : "text-sm justify-start"}
                        ${location.pathname === "/staff/settings" ? "bg-yorkOrange text-white" : "hover:bg-gray-300 hover:text-gray-700 text-gray-700"}
                    `}
                    >
                    {sidebarCollapsed ? (
                        <span className="text-base"><IoSettingsOutline size={22}/></span> // or an actual icon
                    ) : (
                        "Settings"
                    )}
                </Link>
                <Button
                    isIconOnly
                    onClick={handleLogout}
                    radius="none"
                    className={`
                        w-full text-left px-4 py-2 flex items-center transition-colors bg-white
                        ${sidebarCollapsed ? "w-[59px] justify-center text-[0px]" : "text-sm justify-start"}
                        hover:bg-gray-300 hover:text-gray-700 text-gray-700 focus:outline-none hover:border-white 
                    `}
                    >
                    {sidebarCollapsed ? (
                        <span className="text-base"><RiLogoutBoxLine size={22} /></span>
                    ) : (
                        "Logout"
                    )}
                </Button>
            </nav>
          </div>
          <div className="border-t border-gray-200">
          <Button
            isIconOnly
            variant="light"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            className={`
                w-full focus:outline-none hover:border-white transition-all duration-300 justify
                ${sidebarCollapsed ? "w-[59px] justify-center px-0" : "justify-end px-4"}
            `}
            >
            {sidebarCollapsed ? "›" : "‹ Collapse"}
            </Button>
          </div>
        </aside>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto">
          <Outlet /> {/* <-- Render child routes here */}
        </main>
      </div>
    </div>
  );
};

export default StaffLayout;
